import React from "react"
import { Routes, Link, Route, BrowserRouter } from "react-router-dom"
import ExpungeGrid from "./components/expungeGrid"
import Expungement from "./pages/Expungement/Expungement"
import Home from "./pages/Home"
import Stories from "./pages/success-stories/success-stories"
import Resources from "./pages/Resources/Resources"
import Job_readiness_page from "./pages/Job_readiness_page/Job_readiness_page"
import Navbar from "./features/navbar/Navbar"
import Footer from "./features/footer/Footer"
import Contact from "./pages/Contact_Us/contact_us"
import Eligibility from "./pages/Eligibility/Eligibility"
import AboutUs from "./pages/about_us/about_us"

function About() {
  return <h2>About</h2>
}

function Users() {
  return <h2>Users</h2>
}

function App() {
  return (
    <BrowserRouter>
      <div>
        <Navbar />
        {/* A <Switch> looks through its children <Route>s and
          renders the first one that matches the current URL. */}
        <Routes>
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/contact-us" element={<Contact />} />
          <Route path="/success-stories" element={<Stories />} />
          <Route path="/users" element={<Users />} />
          <Route path="/resources" element={<Resources />} />
          {/*<Route path="/jobs-readiness" element={<Job_readiness_page />} />*/}
          <Route path="/" element={<Home />} />
          <Route path="/expungement" element={<Expungement />} />
          <Route path="/check-eligibility" element={<Eligibility />} />
        </Routes>
        <Footer />
      </div>
    </BrowserRouter>
  )
}

export default App
